import React from 'react';
import { connect } from 'react-redux';
import _includes from 'lodash/includes';
import _map from 'lodash/map';
import _reject from 'lodash/reject';
import _size from 'lodash/size';
import PropTypes from 'prop-types';
// Core components
import Avatar from 'components/core/Avatar';
// Models
import {
  sortRegularElements, color, getOnDemand,
} from 'models/cpm/parkingCategory';
// Custom
import { cpmParkingCategoryDataShape } from 'constants/PropTypesShapes';
import ResourcesSelectField from 'components/inputFields/ResourcesSelectField';
import ParkingCategoryTitle from './ParkingCategoryTitle';

const buildParkingCategoryItem = (parkingCategory) => ({
  id: parkingCategory.id,
  parkingCategory, // Store whole parking category to use it in ParkingCategoryTitle
  itemCustomIcon: (
    <Avatar backgroundColor={color(parkingCategory)} size={20} variant="rounded">
      <div />
    </Avatar>
  ),
});

const parkingCategoryItemLabel = (parkingCategoryItem) => {
  // Divider
  if (parkingCategoryItem.divider) {
    return '';
  }

  return (
    <ParkingCategoryTitle parkingCategory={parkingCategoryItem.parkingCategory} />
  );
};

const ParkingCategoriesSelectField = ({
  parkingCategories, withOnDemand, excludedParkingCategoryIds, displayLabel,
  withNullItem, nullItemLabel, value, required, errorText, readOnly, disabled, margin, onChange,
}) => {
  // Build parking categories array
  // Start with regular ones, excluding the ones that must be excluded
  const allParkingCategories = _map(
    _reject(sortRegularElements(parkingCategories), ({ id }) => _includes(excludedParkingCategoryIds, id)), (parkingCategory) => (buildParkingCategoryItem(parkingCategory)),
  );

  // On-demand category
  if (withOnDemand) {
    // On-demand category
    const onDemandParkingCategory = getOnDemand(parkingCategories);
    if (onDemandParkingCategory) {
      // Add a divider
      allParkingCategories.push({
        id: 'divider_1',
        divider: true,
      });
      // Add the parking category
      allParkingCategories.push(buildParkingCategoryItem(onDemandParkingCategory));
    }
  }

  return (
    <ResourcesSelectField
      labelId={displayLabel ? 'field.parkingCategory' : null}
      value={value}
      required={required}
      errorText={errorText}
      resources={allParkingCategories}
      displayKey={parkingCategoryItemLabel}
      readOnly={readOnly || _size(excludedParkingCategoryIds) === _size(parkingCategories)}
      disabled={disabled}
      margin={margin}
      withNullItem={withNullItem}
      nullItemLabel={nullItemLabel}
      onChange={onChange}
    />
  );
};

ParkingCategoriesSelectField.propTypes = {
  parkingCategories: PropTypes.arrayOf(cpmParkingCategoryDataShape).isRequired,
  withOnDemand: PropTypes.bool,
  excludedParkingCategoryIds: PropTypes.arrayOf(PropTypes.number),
  displayLabel: PropTypes.bool,
  withNullItem: PropTypes.bool,
  nullItemLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  value: PropTypes.number,
  required: PropTypes.bool,
  errorText: PropTypes.string,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  margin: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

ParkingCategoriesSelectField.defaultProps = {
  withOnDemand: true,
  excludedParkingCategoryIds: [],
  displayLabel: true,
  withNullItem: false,
  nullItemLabel: null,
  value: null,
  required: false,
  errorText: null,
  readOnly: false,
  disabled: false,
  margin: 'normal',
};

const mapStateToProps = (state) => ({
  parkingCategories: state.cpmCarparkParkingCategory.list.elements || [],
});

module.exports = connect(
  mapStateToProps,
)(ParkingCategoriesSelectField);



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/parkingCategories/ParkingCategorySelectField.js